<div class="toast-stack">
  <div
    *ngFor="let t of toasts; trackBy: trackById"
    class="toast-card toast-{{ t.type }}"
    [class.removing]="t.removing"
    (click)="remove(t.id)"
  >
    <div class="toast-icon">

      <svg *ngIf="t.type === 'success'" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.8" fill="rgba(16,185,129,0.15)"/>
        <path d="M7 12.5l3.5 3.5 6.5-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <svg *ngIf="t.type === 'error'" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.8" fill="rgba(239,68,68,0.15)"/>
        <path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>

      <svg *ngIf="t.type === 'warning'" viewBox="0 0 24 24" fill="none">
        <path d="M12 3L2.5 20.5h19L12 3z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" fill="rgba(245,158,11,0.15)"/>
        <path d="M12 10v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="17.5" r="0.8" fill="currentColor"/>
      </svg>

      <svg *ngIf="t.type === 'info'" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.8" fill="rgba(59,130,246,0.15)"/>
        <path d="M12 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="7.5" r="0.8" fill="currentColor"/>
      </svg>

    </div>

    <div class="toast-body">
      <span class="toast-title">{{ t.type | titlecase }}</span>
      <span class="toast-msg">{{ t.message }}</span>
    </div>

    <button class="toast-close" (click)="remove(t.id)">
      <svg viewBox="0 0 14 14" fill="none">
        <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </button>

    <div class="toast-progress" [style.animation-duration]="(t.duration ?? 4000) + 'ms'"></div>
  </div>
</div>
